// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__FieldRenderers__SyncFieldButton__root","syncTime":"CentricUI__FieldRenderers__SyncFieldButton__syncTime","disabled":"CentricUI__FieldRenderers__SyncFieldButton__disabled","spinnerButton":"CentricUI__FieldRenderers__SyncFieldButton__spinnerButton","spin":"CentricUI__FieldRenderers__SyncFieldButton__spin","syncIconContainer":"CentricUI__FieldRenderers__SyncFieldButton__syncIconContainer","syncButton":"CentricUI__FieldRenderers__SyncFieldButton__syncButton","buttonText":"CentricUI__FieldRenderers__SyncFieldButton__buttonText"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/SyncFieldButton.css
// module id = 1037
// module chunks = 10